import React from 'react';
import './HwzTitle.less';
import HwzComponent from '../../common/component/HwzComponent';

interface IProps {
  name: React.ReactNode;
}

interface IState {}

/**
 * 标题导航快捷插件
 */
export default class HwzTitle extends HwzComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="widget-hwz-title">
        <span className="item active">{this.props.name}</span>
        <span className="tool">{this.props.children}</span>
      </div>
    );
  }
}
